$(document).ready(function() {
const modal = document.getElementById("sizeModal");

document.getElementById("size_popup").addEventListener("click", function() {
  modal.style.display = "flex";
});

document.getElementById("closeModal").addEventListener("click", function() {
  modal.style.display = "none";
});

modal.addEventListener("click", function(e) {
  if (e.target === modal) {
    modal.style.display = "none";
  }
});
});